import axios from './axios'
import NProgress from 'nprogress'
import { Result } from '@/service/model'

interface Reauest {
  responseType: string
  get<T>(url: string, params?: unknown): Promise<Result<T>>
  post<T>(url: string, params?: any, isArraybuffer?: boolean): Promise<Result<T>>
  upload<T>(url: string, params: unknown): Promise<Result<T>>
  download(url: string): void
}

// 不可枚举附加响应元信息（status / 请求url / 请求体）：
// 不影响 JSON.stringify / Object.keys / 展开等既有用法，老调用方零感知
function attachResMeta(data: any, meta: { status?: number; url?: string; params?: unknown }) {
  if (data && typeof data === 'object') {
    Object.defineProperty(data, '__resMeta', {
      value: meta,
      enumerable: false,
      configurable: true
    })
  }
  return data
}

const request: Reauest = {
  get(url, params) {
    return new Promise((resolve, reject) => {
      NProgress.start()
      axios
        .get(url, { params })
        .then((res) => {
          NProgress.done()
          // res 可能为空（错误拦截器未 re-throw），判空原样 resolve，不挂 meta
          resolve(
            attachResMeta(res?.data, {
              status: res?.status,
              url: res?.request?.responseURL || res?.config?.url,
              params: res?.config?.data
            })
          )
        })
        .catch((err) => {
          NProgress.done()
          reject(
            attachResMeta(err, {
              status: err?.response?.status,
              url: err?.config?.url,
              params: err?.config?.data
            })
          )
        })
    })
  },
  post(url, params?: any, isArraybuffer?: boolean) {
    const { switchApi = null, ...restParams } = (params || {}) as Record<string, any>
    const requestBody = Object.keys(restParams).length > 0 ? JSON.stringify(restParams) : undefined
    return new Promise((resolve, reject) => {
      NProgress.start()
      axios
        .post(switchApi || url, requestBody, {
          responseType: isArraybuffer ? 'arraybuffer' : 'json'
        })
        .then((res) => {
          NProgress.done()
          // res 可能为空（错误拦截器未 re-throw），判空原样 resolve，不挂 meta
          resolve(
            attachResMeta(res?.data, {
              status: res?.status,
              url: res?.request?.responseURL || res?.config?.url,
              params: res?.config?.data
            })
          )
        })
        .catch((err) => {
          NProgress.done()
          reject(
            attachResMeta(err, {
              status: err?.response?.status,
              url: err?.config?.url,
              params: err?.config?.data
            })
          )
        })
    })
  },
  upload(url, file) {
    return new Promise((resolve, reject) => {
      NProgress.start()
      axios
        .post(url, file)
        .then((res) => {
          NProgress.done()
          // res 可能为空（错误拦截器未 re-throw），判空原样 resolve，不挂 meta
          resolve(
            attachResMeta(res?.data, {
              status: res?.status,
              url: res?.request?.responseURL || res?.config?.url,
              params: res?.config?.data
            })
          )
        })
        .catch((err) => {
          NProgress.done()
          reject(
            attachResMeta(err, {
              status: err?.response?.status,
              url: err?.config?.url,
              params: err?.config?.data
            })
          )
        })
    })
  },
  download(url) {
    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.src = url
    iframe.onload = function () {
      document.body.removeChild(iframe)
    }
    document.body.appendChild(iframe)
  },
  responseType: ''
}
export default request
